<template lang="pug">
v-row.match-height
  v-col
    v-card.px-0(:loading="busy")

      edit-form-action-bar.mb-4(
        v-bind="$props"
        :entity="entity"
        :data="set"
        :row="row"
        :actions="pageActions"
        @perform="perform"
        @refresh="refresh"
        @clear="clear"
      )

      //- action-bar-ex.mb-4(
      //-   :entity="entity"
      //-   :context="expressionContext"
      //-   @perform="perform"
      //- )
      //-   template(#right)
      //-     v-tooltip(bottom)
      //-       template(#activator="{ on, attrs }")
      //-         v-btn.mx-1(
      //-           icon
      //-           v-bind="attrs"
      //-           v-on="on"
      //-           @click="clear(false)"
      //-         )
      //-           v-icon mdi-broom
      //-       span
      //-         span.text-md.font-weight-medium Limpar
      //-         br
      //-         span.font-weight-light Limpa o conteúdo dos campos editáveis.

      //-     v-tooltip(bottom)
      //-       template(#activator="{ on, attrs }")
      //-         v-btn.mx-1(
      //-           icon
      //-           v-bind="attrs"
      //-           v-on="on"
      //-           @click="clear(true)"
      //-         )
      //-           v-icon mdi-undo-variant
      //-       span
      //-         span.text-md.font-weight-medium Reverter
      //-         br
      //-         span.font-weight-light Reverte as alterações para o estado inicial.

      //-     v-tooltip(bottom)
      //-       template(#activator="{ on, attrs }")
      //-         v-btn.mx-1(
      //-           icon
      //-           v-bind="attrs"
      //-           v-on="on"
      //-           @click="refresh"
      //-         )
      //-           v-icon mdi-refresh
      //-       span
      //-         span.text-md.font-weight-medium Atualizar
      //-         br
      //-         span.font-weight-light Sincroniza os dados da grade com o servidor de dados.

      //- FORMULARIO
      v-card-text
        v-form(
          ref="form"
          lazy-validation
          @submit.prevent
        )
          //- Campos Ocultos
          widget-hidden(
            v-for="(field,index) in hiddenFields"
            :key="`hidden-${index}`"
            :field="field"
            v-model="field.value"
          )

          //- Campos do Formulário
          v-row(v-if="visibleFields.length")
            v-col.pb-0(
              v-for="(field,index) in visibleFields"
              :key="`widget-${index}`"
              :md="fieldExtent(field)"
            )
              widget(
                :field="field"
                :context="expressionContext"
                ref="widget"
                outlined
                v-model="field.value"
                @click="callAction"
              )

          //- Barra de Ação
          div.pr-4.mt-4(v-if="formActions.length")
            widget.mr-2(
              v-for="(action,index) in formActions"
              :key="`action-${index}`"
              :action="action"
              :context="expressionContext"
              type="Link"
              @click="callAction"
            )

  //- Diálogo de confirmação de operação
  action-dialog(
    v-bind="$props"
    :request="request"
    @actionComplete="actionComplete"
    @actionTerminate="actionTerminate"
  )
</template>

<script>
import { findRels } from '@/helpers/rels'
import { interpolate, isInterpolated } from '@/helpers/strings'
import { solveExpressionProperty } from '@/helpers/expressions'
import { performAction } from '@/helpers/actions'
import { parseEref } from '@/helpers/erefs'

import EditFormActionBar from './EditFormActionBar'
import ActionDialog from '@/components/commons/action-dialog/ActionDialog'
import Widget from '@/components/widgets/Widget'
import WidgetHidden from '@/components/widgets/WidgetHidden'

export default {
  components: {
    EditFormActionBar,
    ActionDialog,
    Widget,
    WidgetHidden,
  },

  props: {
    site: String,
    eref: String,
    form: Object,
    data: Object,
    busy: Boolean,

    /** @type {Keep.Paper.Design.Entity} */
    entity: Object,
    /** @type {Keep.Paper.Design.Form} */
    edit: Object,
  },

  data: () => ({
    /**
     * Registros selecionados na grade.
     * @type {Object}
     *    Format:
     *    {
     *      -- Link da requisição
     *      link: {Keep.Paper.Design.Link}
     *      -- Registros afetados pela requisição.
     *      selection: {Array}
     *    }
     */
    request: null, // Parâmetros de requisição
  }),

  computed: {
    fields() {
      const items = this.edit?.fields || []
      items.filter(item => item.expression).forEach(item => {
        solveExpressionProperty(item, item, this.expressionContext)
      })
      return items
    },

    formActions() {
      const links = this.edit.links || []
      const items = findRels(links, 'Action')
      items.filter(item => item.expression).forEach(item => {
        solveExpressionProperty(item, item, this.expressionContext)
      })
      return items.filter(item => !item.hidden)
    },

    hiddenFields: vm => vm.fields.filter(field => field.hidden),
    visibleFields: vm => vm.fields.filter(field => !field.hidden),
    // Campos que devem ser enviados com o formulário no ato de execução de ações.
    nonTransientFields: vm => vm.fields.filter(field => !field.transient),

    set () {
      const sets = this.entity?.dataSet?.sets
      if (!sets) return {}

      const key = this.edit.set
      const set = key
        ? sets.filter(s => s.name === key)[0]
        : sets.filter(s => !s.name || s.name?.toLowerCase() === 'default')[0]

      return set || {}
    },

    row() {
      return this.set.rows?.[0] || {}
    },

    // Retorna um objeto contendo os campos válidos que podem ser usados em um contexto
    // de expressão dinâmica.
    formData() {
      const items = this.edit?.fields || []
      const result = {}

      items.forEach(item => {
        if (item.name) {
          // Usando Vue.set para garantir que as propriedades sejam reativas
          this.$set(result, item.name, item.value)
        }
      })

      return result
    },

    // Contexto para resolução de expressões com /helpers/expression.js.
    expressionContext() {
      return {
        site: this.site,
        eref: parseEref(this.eref),
        page: this.entity,
        data: this.data || this.entity?.dataSet?.sets?.[0] || null,
        form: this.formData,
        row: this.row
      }
    },

    /**
     * Este método processa as ações e as organiza em várias categorias e escopos.
     * As categorias são:
     * - page - Ações de página
     * - data - Ações do conjunto de dados selecionados na página.
     * - row - Ações executadas no registro sem a necessidade de seleção.
     *
     * @returns {Object} - Uma estrutura de ações organizada por categorias e escopos.
     * @example
     * {
     *   page: {
     *     menu: {
     *       all: [...], // Todas as ações da página
     *       main: [...], // Ações principais da página
     *       side: [...], // Ações secundárias da página
     *       rest: [...], // Outras ações da página
     *       categories: [
     *         { name: 'Category1', actions: [...] }, // Categorias personalizadas
     *         { name: 'Category2', actions: [...] },
     *         // ...
     *       ]
     *     },
     *     pins: {
     *       all: [...], // Todas as ações fixadas da página
     *       main: [...], // Ações principais fixadas da página
     *       side: [...], // Ações secundárias fixadas da página
     *       rest: [...], // Outras ações fixadas da página
     *       categories: [
     *         { name: 'Category1', actions: [...] }, // Categorias personalizadas
     *         { name: 'Category2', actions: [...] },
     *         // ...
     *       ]
     *     },
     *     states: {
     *       all: [...], // Todos os monitores de estado da página
     *       main: [...], // Monitores de estado da página
     *       side: [...], // Monitores de estado secundários da página
     *       rest: [...], // Outros monitores de estado da página
     *       categories: [
     *         { name: 'Category1', actions: [...] }, // Categorias personalizadas
     *         { name: 'Category2', actions: [...] },
     *         // ...
     *       ]
     *     }
     *   },
     *   data: { /* ... * / }, // Estrutura semelhante para as ações de dados
     *   row: { /* ... * / }  // Estrutura semelhante para as ações de linha
     * }
     */
    actions() {
      return this.entity.actions
    },

    pageActions() {
      return this.actions.page
    },
  },

  watch: {
    row: "unwrapModel",
  },

  mounted() {
    this.unwrapModel();
  },

  methods: {
    actionComplete({ action }) {
      const refresh = action?.rule?.some(rule => rule === 'Refresh')
      if (refresh) {
        this.refresh()
      }
    },

    actionTerminate({ status }) {
      const redirect = status?.entity?.see

      this.request = null

      // devemos redirecionar?
      if (redirect) {
        this.$close(this.entity)
        this.$go(redirect)
      }
    },

    refresh () {
      const form = { ...this.form }
      const data = this.data

      this.fields.forEach(field => form[field.name] = field.value)

      this.clear(true)
      this.$emit('refresh', { form, data, noCache: true })
    },

    fieldExtent: field => field.extent || 4,

    clear (reset) {
      const { form, widget: widgets } = this.$refs
      form.resetValidation()
      widgets.forEach(widget => {
        reset ? widget.field?.reset() : widget.field?.clear()
      })
      // const forms = this.$refs.forms
      // forms.forEach(form => form.clear(reset))
    },

    unwrapModel () {
      if (!this.entity || this.entity.unwrapped)
        return

      const { row, fields } = this
      fields.forEach(field => field.reset({ value: row[field.name] }))

      this.entity.unwrapped = true
    },

    format(text) {
      return isInterpolated(text) ? interpolate(text, this.context) : text
    },

    callAction(opts) {
      const ok = this.$refs.form.validate()
      if (!ok)
        return

      const { fields, row } = this

      const form = {}
      fields.forEach(field => form[field.name] = field.value)

      const link = { ...(opts.link || opts.action), form }
      const args = opts
      const selection = row

      this.perform({ link, args, selection })
    },

    perform (opts) {
      const context = {
        site: this.site,
        eref: parseEref(this.eref),
        page: this.entity,
        data: this.set,
        row: this.row
      }
      performAction(this, opts, context)
    },
  },
}
</script>
